var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93877 17.7975C9.0624 16.6849 9.01067 16.8134 9.1343 15.7007C9.1343 15.0826 9.25793 14.4645 9.25793 13.8463C9.25793 13.4754 9.38156 13.2282 9.62882 12.9809C12.8431 10.0139 16.1811 7.17042 19.3954 4.20335C19.519 4.07972 19.6427 4.07972 19.6427 3.95609C19.7663 3.70884 19.7663 3.58521 19.5191 3.58521C19.2718 3.58521 18.9009 3.70884 18.9009 3.83246C17.7883 4.4506 16.7992 5.19237 15.6866 5.81051C12.7195 7.66493 9.62881 9.64297 6.66174 11.4974C6.41448 11.621 6.29085 11.621 6.0436 11.621C4.31281 11.0029 2.70566 10.632 0.974865 10.0139C0.851237 10.0139 0.60397 9.89023 0.480342 9.7666C-0.137797 9.39572 -0.137786 9.02484 0.356726 8.65395C0.603982 8.4067 0.974862 8.28307 1.22212 8.15944C3.07654 7.5413 4.6837 6.79953 6.53812 6.18139C11.8541 4.20335 17.0465 2.10167 22.3625 0.123628C22.6098 -1.19743e-07 22.9806 0 23.1043 0C23.846 0 24.0933 0.618139 23.9696 1.35991C23.7224 2.47256 23.4751 3.58521 23.3515 4.69786C22.7334 8.03581 21.868 11.2501 21.2498 14.7117C20.879 16.1953 20.6317 17.5552 20.3844 18.9151V19.286C20.0136 20.5222 19.1482 20.5222 18.4064 19.9041C17.0465 18.9151 15.6866 17.926 14.3267 16.937C13.9558 16.5661 13.5849 16.3189 13.214 16.0716C13.0904 15.948 12.9668 15.948 12.8431 16.0716C11.9777 16.937 10.9887 17.8024 10.247 18.6678C9.44705 19.3224 8.93877 18.8988 8.93877 17.7975Z",
    fill: "url(#paint0_linear_5580_23095)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5580_23095",
    x1: 21.3828,
    y1: -1.9338e-7,
    x2: -10.9889,
    y2: 25.8955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2037"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f35f301254c329cf2c75733198e7e0c1.svg";
export { ForwardRef as ReactComponent };